import "./ColorArticleBanner.css";

const ARTICLE_URL = "https://photobook.magicboard.shop/cvet";
const PUBLIC_BASE = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

export default function ColorArticleBanner() {
  return (
    <div className="color-article-banner">
      <a
        className="color-article-banner__card"
        href={ARTICLE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Читать статью: почему цвета на экране и в фотокниге могут отличаться? Откроется в новой вкладке"
      >
        <h3 className="color-article-banner__title">
          <span>Почему цвета</span>
          <span>на экране и в фотокниге</span>
          <span>могут отличаться?</span>
        </h3>

        <div className="color-article-banner__media">
          <img
            className="color-article-banner__image"
            src={`${PUBLIC_BASE}/assets/color-screen-vs-print.webp`}
            alt=""
            width="1680"
            height="1288"
            loading="lazy"
            decoding="async"
          />
          <span className="color-article-banner__button">Читать статью</span>
        </div>
      </a>
    </div>
  );
}